import { render, staticRenderFns } from "./CantidadRNR.vue?vue&type=template&id=665126b6&scoped=true&"
import script from "./CantidadRNR.vue?vue&type=script&lang=js&"
export * from "./CantidadRNR.vue?vue&type=script&lang=js&"
import style0 from "./CantidadRNR.vue?vue&type=style&index=0&id=665126b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665126b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
